export default "__VITE_ASSET__930b13d7__"